import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import Authorities from '../Authorities'
import { styles }  from '../ThingChildren'

class Sponsor extends Authorities
{
    getLocale = () => this.props.locale.things.application.sponsor ;
}

Sponsor.defaultProps =
{
    ...Authorities.defaultProps ,
    member : 'sponsor'
};

Sponsor.propTypes =
{
    ...Authorities.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )(Sponsor) ;